export default "__VITE_ASSET__CvAnWTY2__"